import ReactMarkdown from "react-markdown";
import { classNames } from "@via/utils/helpers";

interface MarkdownMessageProps {
  content: string;
  className?: string;
}

export function MarkdownMessage({
  content,
  className,
}: MarkdownMessageProps): JSX.Element {
  return (
    <div
      className={classNames(
        "prose-pre:whitespace-pre-wrap prose-pre:break-words break-words",
        className ?? ""
      )}>
      <ReactMarkdown
        components={{
          a: props => (
            <a
              {...props}
              target="_blank"
              rel="noreferrer noopener"
              onClick={e => {
                // Some models emit empty hrefs; avoid navigating to current page
                if (!props.href) e.preventDefault();
              }}
              className="text-indigo-700 no-underline hover:underline"
            />
          ),
          code: props => (
            <code
              {...props}
              className="bg-gray-100 px-1 py-0.5 rounded text-sm"
            />
          ),
          h2: props => <h2 {...props} className="text-xl font-bold my-2" />,
          h3: props => <h3 {...props} className="text-lg my-2" />,
          ul: props => <ul {...props} className="list-disc pl-5" />,
          ol: props => <ol {...props} className="list-decimal pl-5" />,
          p: props => <p {...props} className="my-1 leading-relaxed" />,
        }}>
        {content}
      </ReactMarkdown>
    </div>
  );
}
